"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.directoryPicker.selectDirectory': 'Wybierz katalog',
    'googleDrive.directoryPicker.selected': 'Wybrano',
};
